import { getUserData, getUserLocaleOnlyForMultiLang } from "../util/index";


// Route patterns using React Router path syntax
export const SEARCH_API_ROUTES = {
  RECENT_SEARCH: `/customer/${getUserData().memberId}/preferences/v2/favorites-recent-search`,
  TYPEAHEAD_SUGGESTIONS: `/rci/destinations/typeahead/suggestions/${getUserLocaleOnlyForMultiLang()}`,
  // Add wishlist routes
  ADD_TO_WISHLIST: `/customer/${getUserData().memberId}/preferences/favorites-resort`,
  REMOVE_FROM_WISHLIST: `/customer/${getUserData().memberId}/preferences/favorites-resort`,
  RECENT_SEARCH_POST_URL: (memberId: string) => `/customer/${memberId}/preferences/favorites-recent-search?locale=${getUserLocaleOnlyForMultiLang()}&customerIdQ=${memberId}&languageQ=${getUserData().language.code}`,
  LISTVIEW_URL: `/resort-operations/v1/resorts/weeks/list-view`,
  MAPVIEW_URL: `/resort-operations/v1/resorts/weeks/map-view`,
  RESORT_DETAILS: (resortCode: string, locale: string) => `/resort-operations/v1/resorts/details/${resortCode}?localeQ=${locale}&customerIdQ=${getUserData().memberId}`,
  AVAILABLE_UNITS_PAGE_URL: (productType : string) => {
    return `/pan-weeks-dashboard/${productType}/availableunits`;
  },
  GET_ARN_PRICING: `/rci/search/hotels/all-inclusive/availabilities?customerIdQ=${getUserData().memberId}&applyAims=false`,
  GET_HOTEL_PRICING: `/rci/search/hotels/availability`,
  DYNAMIC_FILTER_CALENDAR: `/resort-operations/v1/resorts/weeks/filters/dynamic`,
  SSO_PATH: (memberId: string) => `/utility/sso/arn/member/${memberId}/member-token?realtime=true&customerIdQ=${memberId}`,
  ADDITIONAL_PARAM_AIMS: (arnhotelId: string, virtualAiFlag: boolean, minDateVal: string, maxDateVal: string) => `&type=property&property=${arnhotelId}&aims=${virtualAiFlag}&checkIn=${minDateVal}&checkOut=${maxDateVal}&currency=${getUserData()?.currencies?.[0]?.code}`,
  PAGERULE_BANNER_API: (() => {
    const userData = getUserData();
    const locale = userData.locale || 'en_US';
    // Convert locale format from en_US to us/en
    const [language, country] = locale.split('_');
    const localePath = country && language ? `${country.toLowerCase()}/${language.toLowerCase()}` : 'us/en';
    return `/content/panorama/rci/post-wow/${localePath}/navigation/search-message-banner.model.json`;
  })(),
  // Translation API endpoint function
  TRANSLATION_API: (language?: string) => {
    const userData = getUserData();
    const locale = language || userData.locale || 'en_US';
    const queryParams = new URLSearchParams({
      customerIdQ: String(userData.memberId),
    });
    return `/utilities/refinements/search-terms/translations/${locale}?${queryParams.toString()}`;
  },
} as const;
